import { FormEvent, useEffect, useState } from 'react';

import { IconKey } from '@tabler/icons-react';

import { Link, createFileRoute, useRouter, useSearch } from '@tanstack/react-router';

import { Button, PasswordInput, Stack, Text, TextInput, Title } from '@optiro/ui';

import useAcceptInvitation from '@/hooks/useAcceptInvitation/useAcceptInvitation';

export const Route = createFileRoute('/experiences/accept-invitation')({
  component: AcceptInvitationPage,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      token: typeof search.token === 'string' ? search.token : '',
    };
  },
});

function AcceptInvitationPage() {
  const search = useSearch({ from: '/experiences/accept-invitation' });
  const [token, setToken] = useState(search.token);
  const [password, setPassword] = useState('');
  const mutation = useAcceptInvitation();
  const router = useRouter();

  useEffect(() => {
    if (mutation.isSuccess) {
      router.navigate({ to: '/experiences/login' });
    }
  }, [mutation.isSuccess, router]);

  const handleAccept = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!token || !password) return;
    mutation.mutate({ token, password });
  };

  return (
    <div className="flex items-center justify-center min-h-[80vh] p-4 bg-gray-50">
      <form onSubmit={handleAccept} className="flex flex-col gap-2 w-full mx-auto max-w-[400px]">
        <Stack gap="md">
          <Title order={2} ta="center">
            Accepter invitation
          </Title>

          <TextInput
            required
            hidden
            size="lg"
            value={token}
            onChange={(e) => setToken(e.currentTarget.value)}
            placeholder="Indsæt din invitation token"
            disabled={mutation.isPending}
          />

          <PasswordInput
            label="Vælg kodeord"
            required
            size="lg"
            value={password}
            onChange={(e) => setPassword(e.currentTarget.value)}
            leftSection={<IconKey size={18} />}
            placeholder="Vælg et kodeord"
            disabled={mutation.isPending}
          />

          <Button type="submit" size="lg" fullWidth loading={mutation.isPending}>
            Opret konto
          </Button>

          {mutation.isSuccess && (
            <Text ta="center" size="sm" c="green">
              Invitation accepteret! Du er nu oprettet.
            </Text>
          )}
          {mutation.isError && (
            <Text ta="center" size="sm" c="red">
              {mutation.error?.response?.data?.error || 'Noget gik galt'}
            </Text>
          )}

          <Text ta="center" size="sm">
            <Link to="/experiences/login" className="text-blue-600 hover:underline">
              Tilbage til login
            </Link>
          </Text>
        </Stack>
      </form>
    </div>
  );
}
